import React, { useState } from "react";
import {Modal, Form, Input, Row, Col, Select, Checkbox} from "antd";
import {useTranslate} from "../../../../../hooks/translate.hook";
import { AxiosError } from "axios";
import { ErrorResponseData } from "../../../../../models/core/response";
import {BranchAddress, BranchAddressRequestValues} from "../../../../../models/branches/branch-data";
import {UIInputWidgetCountry} from "../../../../common/ui/input/widget/country/ui.input.widget.country";
import {UiInputWidgetCity} from "../../../../common/ui/input/widget/city/ui.input.widget.city";
import {UiInputWidgetCityArea} from "../../../../common/ui/input/widget/city-area/ui.input.widget.city-area";

interface AgentDataContactsModalProps {
    item?: BranchAddress | undefined;
    onSubmit: (values: BranchAddressRequestValues, item: BranchAddress | undefined) => Promise<any>;
    onClose: () => void;
}

export const AddressListModal: React.FC<AgentDataContactsModalProps> = ({item, onSubmit, onClose}) => {

    const t = useTranslate();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    let initialValues: any = {};
    if (item) {
        initialValues = {
            name: item.name,
            regNumber: item.regNumber,
            customsCode: item.customsCode,
            zip: item.zip,
            country: item.country.id,
            city: item.city,
            street: item.street,
            email: item.email,
            phone: item.phone,
        }
    }

    return (
        <Modal
            open
            confirmLoading={loading}
            title={t(item ? "EDIT" : "ADD")}
            okText={t(item ? "SAVE" : "ADD")}
            cancelText={t("CANCEL")}
            onOk={() => form.submit()}
            onCancel={() => {
                onClose();
                form.resetFields();
            }}
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={initialValues}
                onFinish={() =>
                    form.validateFields().then((values) => {
                        setLoading(true);
                        onSubmit(values, item)
                            .then(
                                () => {
                                    !item && form.resetFields();
                                    return onClose();
                                },
                                (e: AxiosError<ErrorResponseData>) => {
                                    if (e.response?.data.fields) {
                                        form.setFields(
                                            e.response?.data?.fields
                                        );
                                    }
                                }
                            )
                            .then(
                                () => {},
                                (e) => form.setFields(e.response?.data?.fields)
                            )
                            .finally(() => setLoading(false));
                    })
                }
            >
                <Row gutter={10}>
                    <Col span={24}>
                        <Form.Item
                            name="name"
                            label={t("COMPANY_NAME")}
                            rules={[
                                {
                                    required: true,
                                    message: t("FROM.ERROR.PLEASE_ENTER_VALUE"),
                                },
                            ]}
                        >
                            <Input disabled={loading} type="text" placeholder={t("NAME")} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="regNumber" label={t("REG_NUMBER")}>
                            <Input disabled={loading} type="text" placeholder={t("REG_NUMBER")} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="customsCode" label={"EORI"}>
                            <Input disabled={loading} type="text" placeholder={"EORI"} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="zip"
                            label={t("INDEX")}
                            rules={[
                                {
                                    required: true,
                                    message: t("FROM.ERROR.PLEASE_ENTER_VALUE"),
                                },
                            ]}
                        >
                            <Input disabled={loading} type="text" placeholder={t("ADDRESS")} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="country"
                            label={t("COUNTRY")}
                            rules={[
                                {
                                    required: true,
                                    message: t("FROM.ERROR.PLEASE_ENTER_VALUE"),
                                },
                            ]}
                        >
                            <UIInputWidgetCountry />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="city"
                            label={t("CITY")}
                            rules={[
                                {
                                    required: true,
                                    message: t("FROM.ERROR.PLEASE_ENTER_VALUE"),
                                },
                            ]}
                        >
                            <Input disabled={loading} type="text" placeholder={t("CITY")} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="street"
                            label={t("ADDRESS")}
                            rules={[
                                {
                                    required: true,
                                    message: t("FROM.ERROR.PLEASE_ENTER_VALUE"),
                                },
                            ]}
                        >
                            <Input disabled={loading} type="text" placeholder={t("ADDRESS")} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={10}>
                    <Col span={12}>
                        <Form.Item
                            name="phone"
                            label={t("PHONE")}
                            rules={[
                                {
                                    required: true,
                                    message: t("FROM.ERROR.PLEASE_ENTER_VALUE"),
                                },
                            ]}
                        >
                            <Input disabled={loading} type="text" placeholder={t("PHONE")} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="email"
                            label={t("EMAIL")}
                            rules={[
                                {
                                    required: true,
                                    message: t("FROM.ERROR.PLEASE_ENTER_VALUE"),
                                },
                            ]}
                        >
                            <Input disabled={loading} type="text" placeholder={t("EMAIL")} />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};
